import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { getStoredConsent, setConsent } from '../lib/analytics';
import { useT } from '../i18n/LanguageContext';

// RGPD cookie banner: shown until the visitor chooses. It always renders (so the
// site is compliant even before analytics is switched on); once a Measurement ID
// exists, Consent Mode keeps analytics_storage denied until "accept". Analytics
// itself is initialised by <GlobalSeoConfig> (it knows the runtime GA4 ID).
export default function CookieConsent() {
  const t = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getStoredConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (granted) => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[70] p-3 sm:p-4">
      <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl border border-white/10 bg-[#14213d] p-5 text-white shadow-[0_24px_60px_-24px_rgba(0,0,0,0.7)] sm:flex-row sm:items-center">
        <Cookie className="hidden h-8 w-8 flex-shrink-0 text-[#c8a25a] sm:block" />
        <p className="flex-1 text-sm leading-relaxed text-white/85">
          {t('cookies.text')}{' '}
          <Link to="/privacy" className="font-semibold text-[#1fa5a3] underline underline-offset-2">
            {t('cookies.policy')}
          </Link>
        </p>
        <div className="flex flex-shrink-0 gap-3">
          <button
            type="button"
            onClick={() => choose(false)}
            className="rounded-full border border-white/25 px-5 py-2.5 text-sm font-semibold text-white/90 transition hover:bg-white/10"
          >
            {t('cookies.reject')}
          </button>
          <button
            type="button"
            onClick={() => choose(true)}
            className="rounded-full bg-[#1fa5a3] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#188b89]"
          >
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
